import React from "react";
import SoftBox from "StyleFeatures/SoftBox";
import SoftTypography from "StyleFeatures/SoftTypography";
import CoverLayout from "Common/CoverLayout";
import curved9 from "assets/images/curved-images/curved-6.jpg";
import { useNavigate } from "react-router-dom";
import SoftButton from "StyleFeatures/SoftButton";

function CheckEmail() {
  const navigate = useNavigate();

  return (
    <CoverLayout
      title="Check Your Email"
      description="We’ve sent a password reset link to your email"
      image={curved9}
      centerHeader
    >
      <SoftBox textAlign="center">
        {/* Message */}
        <SoftTypography variant="h6" fontWeight="bold" mb={2}>
          Password Reset Link Sent
        </SoftTypography>

        <SoftTypography variant="body2" color="text" mb={3}>
          If an account exists with this email, you will receive a password reset link shortly. The
          link will expire in <b>30 minutes</b>.
        </SoftTypography>

        <SoftTypography variant="body2" color="text" mb={4}>
          Please check your inbox and spam folder.
        </SoftTypography>

        {/* Back to login */}
        <SoftButton variant="gradient" color="info" onClick={() => navigate("/signIn")}>
          Back to Login
        </SoftButton>
      </SoftBox>
    </CoverLayout>
  );
}

export default CheckEmail;
